import React, { useState, useEffect } from "react"
import { CSSTransition } from "react-transition-group"
import { useLifecycles } from "react-use"
import { ModalCreditItem } from "./ModalCreditItem"
import Spinner from "../Spinner/Spinner"
import Select from "scripts/components/select"
import currencyFormat from "scripts/utils/currencyFormat"

export const ModalCredits = ()=> {
  const [isOpen, setIsOpen] = useState(true)
  const [shouldSpinnerBeShown, setShouldSpinnerBeShown] = useState(false)
  const { common } = window.phrases.popup.credit
  const product = window.currentProduct.value
  const productImageSrc = (document.querySelector('.card__image') as HTMLImageElement)?.src || ""

  const handleModalClose = (e) => {
    if (!e.target.closest(".modal-content") || e.target.classList.contains("js-close")) {
      e.stopPropagation()
      setIsOpen(false)
    }
  }

  useLifecycles(() => {
    document.documentElement.classList.add("overflow")
    if (window.innerWidth > 880) {
      new Select({
        selector: '.credit__select'
      });
    }
  })

  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        setShouldSpinnerBeShown(false)
      }
    }
    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [])

  const handleSendRequest = (showSpinner:boolean) => {
    setShouldSpinnerBeShown(showSpinner)
  }

  return (
    <>
      <CSSTransition
        in={shouldSpinnerBeShown}
        timeout={300}
        classNames="fade"
        unmountOnExit
      >
        <Spinner />
      </CSSTransition>
      <CSSTransition
        in={isOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
        onExit={() => {
          document.documentElement.classList.remove("overflow")
        }}
      >
        <div
          className="modal modal-credit"
          data-target="modal-credit"
          style={{ display: "block" }}
          onClick={handleModalClose}
        >
          <div className="modal__zoom">
            <div className="modal-content">
              <div className="close-btn js-close" onClick={handleModalClose}></div>
              <div className="modal-credit__content">
                <div className="modal-content__title">{common.title}</div>
                <div className="block-credit">
                  <div className="cart-card flex-s">
                    <div className="cart-card__img flex-c-c">
                      <img src={productImageSrc} alt="" />
                    </div>
                    <div className="cart-card__content flex-c">
                      <div className="cart-card__info">
                        <div className="name">{product.name}</div>
                      </div>
                    </div>
                    <div className="credit-price flex-c">
                      {product.old === 0 ? null : (
                        <div className="price-old flex-c">
                          <div className="selected-old js_selected_old">
                            {currencyFormat(product.old)}
                          </div>
                          <span className="currency">₴</span>
                        </div>
                      )}
                      <div className="price flex-c">
                        <div className="selected-current js_selected_current">
                          {currencyFormat(product.current)}
                        </div>
                        <span className="currency">₴</span>
                      </div>
                    </div>
                  </div>
                  <div className="block-credit__head flex-c">
                    <div className="suggest">{common.offer}</div>
                    <div className="commission">{common.commission}</div>
                    <div className="payment">{common.month}</div>
                  </div>
                  <div className="block-credit__content flex-c">
                    {product.credits.map((credit) => {
                      return (
                        <ModalCreditItem
                          key={credit.code}
                          price={product.current}
                          credit={credit}
                          phrases={common}
                          onSendRequest={handleSendRequest}
                        />
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  )
}